/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { ApplicationState } from '../../reducers';
import { map } from 'rxjs/operators';
import { getValidAuthToken } from '../ngrx/state/auth.state';
import { TokenValidatorService } from '../services/token-validator/token-validator.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private readonly router: Router,
    private readonly authStore: Store<ApplicationState>,
    private readonly tokenValidatorService: TokenValidatorService,
  ) { }

  /**
   * Check if the user is authenticated
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.authStore.select(getValidAuthToken).pipe(
      map((sessionTokenFromCookie) => {
        if (sessionTokenFromCookie) {
          const isTokenExpired = this.tokenValidatorService.isTokenExpired(sessionTokenFromCookie);
          if (!isTokenExpired) {
            this.tokenValidatorService.setTokenToStore(sessionTokenFromCookie);
            return true;
          }
            this.router.navigate(['/login']);
            return false;
        }
          this.router.navigate(['/login']);
          return false;
      }),
    );
  }
}
